<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal size="sm"
                   :visible="modal.show"
                   :data="model"
                   :title="$t('Manage Clerks')"
                   @show="onShow"
                   @hidden="onHidden"
                   @ok.prevent="handleSubmit(onSubmit)"
                   :show-confirmation="showConfirmation"
                   :ok-title="$t('Submit')"
                   :is-loading="loading"
                   scrollable>
      <div class="row mb-1">
        <div class="clerk-select col-md-9">
          <input-widget type="select2" :items="availableClerks" :model=model attribute="clerk"
                        display-field="${item.name}" value-field="uuid" @select2Select="getSelectedClerks()"
                        :disabled="!availableClerks.length"/>
        </div>
        <div class="col-md-3 text-right">
          <b-tooltip target="new-customer-btn" :title="$t('New Clerk')"/>
          <b-button variant="primary" style="margin-top: 2em" id="new-customer-btn" @click="onNewClerkClick">
            <font-awesome-icon icon="user-plus"/>
          </b-button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <table class="table table-sm mb-0 sale-info-table" v-if="selectedClerks.length > 0">
            <tr>
              <td><b>{{ $t('Name') }}</b></td>
              <td><b>{{ $t('Language') }}</b></td>
              <td></td>
            </tr>
            <tr v-for="tag in selectedClerks" :key="tag.uuid">
              <td>{{ tag.name }}</td>
              <td>
                <ul v-if="tag.languages" class="mb-0 pl-3">
                  <li v-for="language in tag.languages" :key="language.uuid">
                    {{ language.name }}
                  </li>
                </ul>
              </td>
              <td class="text-center">
                <b-tooltip :target="`remove-clerk-button-${tag.uuid}`" :title="$t('Delete')"/>
                <font-awesome-icon class="text-danger hover-cursor" :id="`remove-clerk-button-${tag.uuid}`"
                                   @click="removeTag(tag)" style="font-size: 1.5em;margin-top: .3em" :icon="'times'"/>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </artisio-modal>
    <clerks-modal/>
  </ValidationObserver>
</template>

<script>

  import InputWidget from "../../../core/components/input-widget/InputWidget.vue";
  import ArtisioModal from "../../../core/components/artisio-modal/ArtisioModal.vue";
  import {createNamespacedHelpers} from "vuex";
  import AuctionClerk from "@/modules/pre-bids/models/AuctionClerk.model";
  import _ from "lodash";
  import {SOURCE_PRE_BIDS_TABLE} from "@/modules/constants";
  import ClerksModal from "@/modules/setup/branch/tabs/clerks/ClerksModal.vue";

  const {mapState, mapActions} = createNamespacedHelpers('preBids');
  const {mapActions: clerksMapActions} = createNamespacedHelpers('setup/branch');
  const {mapState: mapStateGlobal} = createNamespacedHelpers('global');

  export default {
    name: "ManageClerksModal",
    components: {
      ClerksModal,
      InputWidget,
      ArtisioModal
    },
    data() {
      return {
        loading: false,
        showConfirmation: true,
        model: new AuctionClerk(),
        selectedClerks: []
      }
    },
    computed: {
      ...mapState({modal: state => state.manageClerksModal}),
      ...mapStateGlobal({
        clerks: state => state.currentUser.branch.clerks,
        currentBranch: state => state.currentUser.branch
      }),
      availableClerks() {
        return this.clerks.filter(opt => this.selectedClerks.map(sl => sl.uuid).indexOf(opt.uuid) === -1)
      },
    },
    methods: {
      ...mapActions(['hideManageClerksModal', 'updateSaleClerks']),
      ...clerksMapActions({
        showClerksModal: 'showClerksModal'
      }),
      onShow() {
        this.showConfirmation = true;
        this.selectedClerks = this.modal.object.clerks
      },
      onHidden() {
        this.model = new AuctionClerk();
        this.selectedClerks = [];
        this.hideManageClerksModal();
      },
      async onSubmit() {
        this.loading = true;
        let response = await this.updateSaleClerks({
          uuid: this.modal.object.uuid,
          selectedClerks: this.selectedClerks.map(c => c.uuid)
        })
        this.loading = false;
        if (response.success) {
          this.showConfirmation = false;
          this.hideManageClerksModal();
          this.$toast('success', this.$t('Clerk(s) was successfully updated'));
        } else {
          if (response.toastError) {
            this.$errorDialog(response.toastError);
          } else {
            if (response.body.non_field_errors) {
              this.$errorDialog(response.body.non_field_errors[0]);
            } else {
              this.model.setMultipleErrors(response.body);
            }
          }
        }
      },
      getSelectedClerks() {
        let clerkId = this.model.clerk;
        this.selectedClerks.push(this.clerks.find(l => l.uuid === clerkId))
      },
      removeTag(tag) {
        this.selectedClerks = _.remove(this.selectedClerks, l => l.uuid !== tag.uuid)
        this.model.clerk = '';
      },
      onNewClerkClick() {
        this.showClerksModal({
          object: {
            clerks: this.currentBranch.clerks,
            branch_uuid: this.currentBranch.uuid,
          },
          source: SOURCE_PRE_BIDS_TABLE
        })
      }
    },
  }
</script>

<style scoped>
  /deep/ .form-group {
    margin-bottom: 0.5rem;
  }
</style>
